<nav>
  <div class="navbar-wrapper"
    (mouseenter)="menuState.set('hovered')"
    (mouseleave)="setMenuStateOnLeave()">
    <app-nav-logo [menuState]="menuState()" [navCollapsed]="navCollapsed" (NavCollapse)="navCollapse()" class="navbar-brand header-logo" />
    <app-nav-content [menuState]="menuState()" (NavCollapsedMob)="navCollapseMob()" class="scroll-div w-100" />
  </div>
</nav>
